module.exports = __webpack_public_path__ + "static/media/14.853ccc51.jpg";